"use strict";
var V8_VERSION = require("../internals/environment-v8-version");
var fails = require("../internals/fails");
var globalThis = require("../internals/global-this");
var $String = globalThis.String;
module.exports = !!Object.getOwnPropertySymbols && !fails(function() {
  var symbol = Symbol("symbol detection");
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});
